<template>
<div class='bodyer user'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title'>
                    <img src='/static/image/user/icon-title.png' class='icon-img'>我的通行证
                </div>
            </div>
        </div>
    </div>
    <div class='main'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-3'>
                    <div class='user-info'>
                        <div class='avatar'>
                            <img src='/static/image/user/avatar.png'>
                        </div>
                        <div class='info'>
                            <label>账号：</label>{{user.username}}
                            <button class='yi-btn white-o xs pull-right' 
                                @click='logout()'>退出</button>
                        </div>
                        <div class='info'>
                            <label>应答币：</label>{{user.balance || '0'}}
                            <a class='yi-btn white-o xs pull-right' 
                                data-toggle='modal' data-target='#redeem-game'>兑换</a>
                        </div>
                    </div>
                </div>
                <div class='col-md-9'>
                    <div class='user-safe line-module'>
                        <div class='yi-title'>账号安全</div>
                        <div class='content'>
                            <div class='list-group'>
                                <li class='list-group-item'>
                                    <div class='item'>
                                        账号密码
                                        <a class='pull-right' data-target='#repass' 
                                            data-toggle='modal'>修改</a>
                                    </div>
                                    <div class='tip'>
                                        使通行证登录游戏或平台的重要凭证
                                    </div>
                                </li>
                                <li class='list-group-item'>
                                    <div class='item'>
                                        邮箱认证
                                        <a class='pull-right' data-target='#bind-email' 
                                            data-toggle='modal' v-if='!user.email_bind'>未设置</a>
                                        <span class='pull-right' 
                                            data-toggle='modal' v-if='user.email_bind'>已认证</span>
                                    </div>
                                    <div class='tip'>
                                        安全邮箱可以登录游戏或平台，重置密码或其他安全验证
                                    </div>
                                </li>
                                <li class='list-group-item'>
                                    <div class='item'>
                                        实名认证
                                        <a class='pull-right' data-target='#bind-user' 
                                            data-toggle='modal' v-if='!user.id_card'>未设置</a>
                                        <span class='pull-right'
                                            v-if='user.id_card'>已认证</span>
                                    </div>
                                    <div class='tip'>
                                        完成身份认证，将作为此账号所有权重要凭证，请确保信息真实准确，以免造成不必要的麻烦
                                    </div>
                                </li>
                                <li class='list-group-item'>
                                    <div class='item'>
                                        手机认证
                                        <a class='pull-right' data-target='#bind-mobile' 
                                            data-toggle='modal' v-if='!user.mobile'>未设置</a>
                                        <span class='pull-right' 
                                            data-toggle='modal' v-if='user.mobile'>已认证</span>
                                    </div>
                                    <div class='tip'>
                                        安全手机可以登录游戏或平台，重置密码或其他安全验证
                                    </div>
                                </li>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class='row'>
                <div class='col-md-3'>
                    <div class='fast-entry'>
                        <div class='yi-title'>快速入口</div>
                        <div class='list'>
                            <div class='list-group'>
                                <!-- <li class='list-group-item'>
                                    我的资料
                                </li> -->
                                <li class='list-group-item' @click='toUrl("/recharge")'>
                                    充值中心
                                </li>
                                <li class='list-group-item' @click='toM2Url("/download")'>
                                    游戏下载
                                </li>
                                <li class='list-group-item' @click='toUrl("/service/faq?type=lost")'>
                                    找回被盗
                                </li>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='col-md-9'>
                    <div class='user-recharge line-module'>
                        <div class='yi-title'>我的充值</div>
                        <div class='content'>
                            <div class='line'>
                                应答币余额：<span class='text-danger'>{{user.balance || '0'}}</span>
                                <div class='box-btn pull-right'>
                                    <button class='yi-btn orange sm'
                                        @click='toUrl("/recharge/pay?channel=wx")'>立即充值</button>
                                    <button class='yi-btn orange sm' data-toggle='modal' data-target='#redeem-game'>兑换</button>
                                    <button class='yi-btn orange sm'
                                        @click='toUrl("/recharge/log")'>查询记录</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class='user-game line-module'>
                        <div class='yi-title'>我的游戏</div>
                        <div class='content'>
                            <div class='game' v-for='game in games'>
                                <div class='icon'>
                                    <img :src='game.icon'>
                                </div>
                                <div class='name'>{{game.name}}</div>
                                <div class='tip'>
                                    <button class='yi-btn orange sm' v-if='!game.has'
                                        @click='registerGame(game.id)'>激活</button>
                                    <button class='yi-btn orange sm' v-if='game.has' disabled>已激活</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class='modal modal-form fade' id='repass'>
        <div class='modal-dialog lg'>
            <div class='modal-content'>
                <div class='modal-header'>
                    密码修改
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <div class='modal-body'>
                    <table class='yi-table form'>
                        <tr v-if='user.password'>
                            <th>原密码：</th>
                            <td>
                                <input type='password' v-model='repass.old' class='form-control'>
                            </td>
                        </tr>
                        <tr>
                            <th>新密码：</th>
                            <td><input type='password' v-model='repass.new' class='form-control'></td>
                        </tr>
                        <tr>
                            <th>新密码：</th>
                            <td><input type='password' v-model='repass.re_new' class='form-control'></td>
                        </tr>
                    </table>
                </div>
                <div class='modal-footer'>
                    <button class='btn btn-warning' @click='toRepass()'>提交</button>
                    <button class='btn btn-default' data-dismiss='modal'>取消</button>
                </div>
            </div>
        </div>
    </div>
    <div class='modal modal-form fade' id='bind-email'>
        <div class='modal-dialog lg'>
            <div class='modal-content'>
                <div class='modal-header'>
                    邮箱认证
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <div class='modal-body'>
                    <table class='yi-table form'>
                        <tr>
                            <th>邮箱：</th>
                            <td>
                                <input type='type' v-model='email' class='form-control'>
                            </td>
                        </tr>
                        <!-- <tr>
                            <th>验证码：</th>
                            <td>
                                <div class='input-group'>
                                    <input type='text' v-model='email_code' class='form-control' placeholder='验证码'>
                                    <div class='input-group-btn'>
                                        <button class='btn btn-default' 
                                            @click='sendEmailCode()'
                                            v-bind:disabled='forbid_email !== false'>
                                            {{forbid_email == false ? '发送' : forbid_email}}
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr> -->
                    </table>
                </div>
                <div class='modal-footer'>
                    <button class='btn btn-warning' @click='toBindEmail()'>提交</button>
                    <button class='btn btn-default' data-dismiss='modal'>取消</button>
                </div>
            </div>
        </div>
    </div>
    <div class='modal modal-form fade' id='bind-user'>
        <div class='modal-dialog lg'>
            <div class='modal-content'>
                <div class='modal-header'>
                    实名认证
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <div class='modal-body'>
                    <table class='yi-table form'>
                        <tr>
                            <th>姓名：</th>
                            <td>
                                <input type='text' v-model='truename' class='form-control'>
                            </td>
                        </tr>
                        <tr>
                            <th>身份证号：</th>
                            <td>
                                <input type='text' v-model='id_card' class='form-control'>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class='modal-footer'>
                    <button class='btn btn-warning' @click='toBindUser()'>提交</button>
                    <button class='btn btn-default' data-dismiss='modal'>取消</button>
                </div>
            </div>
        </div>
    </div>
    <div class='modal modal-form fade' id='bind-mobile'>
        <div class='modal-dialog lg'>
            <div class='modal-content'>
                <div class='modal-header'>
                    手机认证
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <div class='modal-body'>
                    <table class='yi-table form'>
                        <tr>
                            <th>手机号</th>
                            <td>
                                <input type='number' v-model='mobile' class='form-control'>
                            </td>
                        </tr><tr>
                            <th>验证码</th>
                            <td>
                                <div class='input-group'>
                                    <input type='number' v-model='sms_code' class='form-control'>
                                    <div class='input-group-append'>
                                        <button class='btn btn-default' @click='sendSms()'
                                            v-bind:disabled='forbid_sms !== false'>
                                            {{forbid_sms == false ? '发送' : forbid_sms}}
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class='modal-footer'>
                    <button class='btn btn-warning' @click='toBindMobile()'>提交</button>
                    <button class='btn btn-default' data-dismiss='modal'>取消</button>
                </div>
            </div>
        </div>
    </div>
    <div class='modal modal-form fade' id='redeem-game'>
        <div class='modal-dialog lg'>
            <div class='modal-content'>
                <div class='modal-header'>
                    游戏币兑换
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <div class='modal-body'>
                    <table class='yi-table form'>
                        <tr>
                            <th>账号</th>
                            <td>
                                <input type='text' :value='user.username' 
                                    class='form-control' disabled>
                            </td>
                        </tr>
                        <tr>
                            <th>钱包</th>
                            <td>
                                <input type='text' :value='user.balance' 
                                    class='form-control' disabled>
                            </td>
                        </tr>
                        <tr>
                            <th>游戏</th>
                            <td>
                                <select v-model="redeemGame.game" class='form-control'>
                                  <option v-for="game in games" v-bind:value="game"
                                    v-bind:disabled='!game.has'>
                                    {{ game.name }}
                                  </option>
                                </select>
                                <p style="font-size: 1.2rem;color:red">如不能选择游戏，请先在我的游戏里激活</p>
                            </td>
                        </tr>
                        <tr>
                            <th>区服</th>
                            <td>
                                <select v-model="redeemGame.server_id" class='form-control'>
                                  <option v-for="server in redeemGame.game.servers" v-bind:value="server.id">
                                    {{ server.number + ':' + server.name }}
                                  </option>
                                </select>
                            </td>
                        </tr>
                        <tr v-if="redeemGame.game.recharge_config == undefined || (redeemGame.game.recharge_config !== undefined && Object.keys(redeemGame.game.recharge_config).length == 0)">
                            <th>兑换数量</th>
                            <td>
                                <div class='input-group'>
                                    <input type='number' v-model='redeemGame.amount'
                                        class='form-control'>
                                    <div class='input-group-addon'>
                                        <span class="input-group-text">应答币</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="redeemGame.game.recharge_config !== undefined && Object.keys(redeemGame.game.recharge_config).length > 0">
                            <th>兑换数量</th>
                            <td>
                                <div class='input-group'>
                                    <select v-model="redeemGame.amount" class='form-control'>
                                        <option v-for="config in redeemGame.game.recharge_config" v-bind:value="config">
                                            {{config}}
                                        </option>
                                    </select>
                                    <div class='input-group-addon'>
                                        <span class="input-group-text">应答币</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr><td colspan="2" style='padding:0px; text-align:center; color: blue'>
                                可兑换游戏{{redeemGame.game.redeem_rate * (redeemGame.amount || 0)}}点，(兑换比率 1:{{redeemGame.game.redeem_rate}})
                        </td></tr>
                    </table>
                </div>
                <div class='modal-footer'>
                    <button class='btn btn-warning' @click='toRedeemGame()' :disabled="isDisable">提交</button>
                    <button class='btn btn-default' data-dismiss='modal'>取消</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import Storage from '@/common/Storage'
import Notify from '@/common/Notify'
import Config from '@/common/Config'
import Common from '@/common/Common'
import Request from '@/common/Request'
import ScrollReveal from 'scrollreveal'
export default {
    data : function(){
        return {
            // 'user' : false
            'repass' : {
                'old' : '',
                'new' : '',
                're_new' : ''
            },
            'email' : '',
            'email_code' : '',
            'forbid_email' : false,
            'mobile' : '',
            'truename' : '',
            'id_card' : '',
            'sms_code' : '',
            'forbid_sms' : false,
            'redeemGame' : {
                'game' : '',
                'server_id' : ''
            },
            'games' : [],
            'servers' : [],
            'isDisable' : false
        }
    },
    props : ['user', 'logout', 'setUser'],
    methods : {
        //修改密码
        toRepass : function(){
            if((this.user.password && !this.repass.old) || !this.repass.new){
                Notify.error('请将信息填写完全!')
                return false
            }
            if(this.repass.new != this.repass.re_new){
                Notify.error('两次密码不一致!')
                return false
            }

            var url = Request.createApi('/app/user/re-password')
            var param = {
                'password' : this.repass.old,
                'new_pass' : this.repass.new
            }

            Request.post(url, param, res => {
                Notify.success('密码修改成功!')
                this.setUser(res.info)
                $('#repass').modal('hide')
            })
        },

        //绑定邮箱
        toBindEmail : function(){
            if(!this.email){
                Notify.error('请将信息填写完全!')
                return false
            }

            var url = Request.createApi('/app/user/send-bind-email')
            var param = {
                'email' : this.email
            }
            Request.post(url, param, res => {
                Notify.success('验证邮件已发送，请注意查收！')
                //this.setUser(res.info)
                $('#bind-email').modal('hide')
            })
        },

        //验证码发送
        sendEmailCode : function(){
            if(!this.email){
                Notify.error('请输入邮箱!')
                return false
            }

            var url = Request.createApi('/public/send-email-code')
            var param = {
                'email' : this.email
            }
            Request.post(url, param, res => {
                Notify.success('验证码已发送!')
                this.forbid_email = 60
                var loop = setInterval(() => {
                    this.forbid_email--
                    if(this.forbid_email < 1){
                        this.forbid_email = false
                        clearInterval(loop)
                    }
                }, 1000)
            })
        },

        //验证码发送
        sendSms : function(){
            if(!this.mobile){
                Notify.error('请输入手机号!')
                return false
            }

            var url = Request.createApi('/public/send-sms-code')
            var param = {
                'mobile' : this.mobile
            }
            Request.post(url, param, res => {
                Notify.success('验证码已发送!')
                this.forbid_sms = 60
                var loop = setInterval(() => {
                    this.forbid_sms--
                    if(this.forbid_sms < 1){
                        this.forbid_sms = false
                        clearInterval(loop)
                    }
                }, 1000)
            })
        },

        //绑定手机号
        toBindMobile : function(){
            if(!this.mobile || !this.sms_code){
                Notify.error('请输入信息!')
                return true
            }

            var url = Request.createApi('/app/user/bind-mobile')
            var param = {
                'mobile' : this.mobile,
                'sms_code' : this.sms_code
            }

            Request.post(url, param, res => {
                Notify.success('绑定成功')
                this.setUser(res.info)
                $('#bind-mobile').modal('hide')
            })
        },

        //实名认证
        toBindUser : function(){
            if(!this.truename || !this.id_card){
                Notify.error('请将信息填写完全!')
                return true
            }

            var url = Request.createApi('/app/user/update')
            var param = {
                'info' : {
                    'truename' : this.truename,
                    'id_card' : this.id_card
                }
            }

            Request.post(url, param, res => {
                Notify.success('认证成功')
                this.setUser(res.info)
                $('#bind-user').modal('hide')
            })
        },

        //加载游戏列表
        getGameList : function(){
            var url = Request.createApi('/app/game/list?mark_has=1')
            Request.get(url, res => {
                this.games = res.list
                // console.log(this.games)
                // this.redeemGame.game = this.games[0]
                // console.log(this.redeemGame.game)
            })
        },
        //兑换游戏
        toRedeemGame : function(){
            if(!this.redeemGame.server_id || !this.redeemGame.amount){
                Notify.error('请将信息填写完全!')
                return false
            }

            var url = Request.createApi('/app/consume/redeem-game')
            var param = {
                'server_id' : this.redeemGame.server_id,
                'amount' : this.redeemGame.amount
            }

            this.isDisable = true;
            Request.post(url, param, res => {
                this.isDisable = false
                Notify.success('兑换成功')
                this.setUser(res.info)
                $('#redeem-game').modal('hide')
            })
        },

        //注册游戏
        registerGame : function(gameId){
            var url = Request.createApi('/app/user-game/add')
            var param = {
                'game_id' : gameId 
            }

            Request.post(url, param, res => {
                Notify.success('游戏激活成功!')
                this.getGameList()
            })
        },

        toUrl : function(url){
            Common.toUrl(url)
        },

        toM2Url : function(url){
            Common.toM2Url(url)
        }
    },
    mounted : function(){
        var sr = ScrollReveal({
            'origin' : 'bottom',
            'distance' : '200px',
            'duration' : 500,
        });

        sr.reveal('.user-safe', {'origin' : 'right'})
            .reveal('.fast-entry')
            .reveal('.user-recharge')
            .reveal('.user-game')
    },
    created : function(){
        window.scrollTo(0, 0)
        
        if(!this.user){
            Common.toUrl('/login')
            return true
        }
        this.email = this.user.email
        this.getGameList()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Index.vue